(function () {
    'use strict';

    angular
        .module('wsl.core')
        .directive('wsl-mediaQueries', mediaQueries);

    mediaQueries.$inject = ['$timeout', '$log', 'enquire', '_'];

    /* @ngInject */
    function mediaQueries($timeout, $log, enquire, _) {
        var directive = {
            link: link,
            restrict: 'A'
        };
        return directive;

        function link(scope, element, attrs) {
            var variant = JSON.parse(attrs['wsl-mediaQueries']);
            if (_.size(variant) == 0) {
                $log.warn('Not found wsl-mediaQueries variants!');
                return;
            }
            if (!variant.xs) {
                $log.warn('Not found wsl-mediaQueries xs variant!');
                return;
            }
            variant.sm = variant.sm ? variant.sm : variant.xs;
            variant.md = variant.md ? variant.md : variant.sm;
            variant.lg = variant.lg ? variant.lg : variant.md;

            if (enquire) {
                var queryXS = 'screen and (min-width: 20px) and (max-width: 767px)',
                    querySM = 'screen and (min-width: 768px) and (max-width: 991px)',
                    queryMD = 'screen and (min-width: 992px) and (max-width: 1299px)',
                    queryLG = 'screen and (min-width: 1300px)',
                    handlerXS = {
                        // OPTIONAL, defaults to false
                        // If set to true, defers execution of the setup function
                        // until the first time the media query is matched
                        deferSetup: false,

                        // OPTIONAL
                        // If supplied, triggered once, when the handler is registered.
                        setup: function() {},

                        // OPTIONAL
                        // If supplied, triggered when a media query matches.
                        match : function() {
                            //  $log.log('handlerXS');
                            if (variant.xs) {
                                updateValues(scope, element, attrs, variant.xs, [variant.sm, variant.md, variant.lg]);
                            }
                        },

                        // OPTIONAL
                        // If supplied, triggered when the media query transitions
                        // *from a matched state to an unmatched state*.
                        unmatch: function() {},

                        // OPTIONAL
                        // If supplied, triggered when handler is unregistered.
                        // Place cleanup code here
                        destroy : function() { console.log('handlerXS destroyed'); }
                    },
                    handlerSM = {
                        deferSetup: false,
                        setup: function() {},
                        match : function() {
                            if (variant.sm) {
                                updateValues(scope, element, attrs, variant.sm, [variant.xs,variant.md, variant.lg]);
                            }
                        },
                        unmatch: function() {},
                        destroy : function() { console.log('handlerSM destroyed'); }
                    },
                    handlerMD = {
                        deferSetup: false,
                        setup: function() {},
                        match : function() {
                            if (variant.md) {
                                updateValues(scope, element, attrs, variant.md, [variant.xs, variant.sm,variant.lg]);
                            }
                        },
                        unmatch: function() {},
                        destroy : function() { console.log('handlerMD destroyed'); }
                    },
                    handlerLG = {
                        deferSetup: false,
                        setup: function() {},
                        match : function() {
                            if (variant.lg) {
                                updateValues(scope, element, attrs, variant.lg, [variant.xs, variant.md, variant.lg]);
                            }
                        },
                        unmatch: function() {},
                        destroy : function() { console.log('handlerLG destroyed'); }
                    };

                enquire.register(queryXS, handlerXS);
                enquire.register(querySM, handlerSM);
                enquire.register(queryMD, handlerMD);
                enquire.register(queryLG, handlerLG);
                //  enquire.unregister(queryXS, handlerXS);
            } else {
                $log.warn('Not found enquire');
            }
        }

        function updateValues(scope, element, attrs, variantsTo, variantsFrom) {
            _.forEach(variantsTo, function (value, key) {
                if (typeof(attrs[attrs.$normalize(key)]) == 'string' && attrs[attrs.$normalize(key)].indexOf('vm.') > -1) {
                    scope.vm.model[attrs.$normalize(key)] = value;
                    $timeout(function() {
                        scope.$apply();
                        if (attrs.hasOwnProperty('istevenMultiSelect') && scope.$$childHead && typeof(scope.$$childHead.refreshButton) == 'function') {
                            scope.$broadcast('refreshButton', scope.vm.model[attrs.$normalize(key)]);
                        }
                    }, 400);
                } else {
                    switch (key) {
                        case 'class' :
                            for (var i = 0; i < variantsFrom.length; i++) {
                                if (variantsFrom[i][key]) {
                                    var classes = variantsFrom[i][key].split(' ');
                                    var has  = true;
                                    for (var j = 0; j < classes.length; j++) {
                                        has = has && element.hasClass(classes[j]);
                                    }
                                    if (has) {
                                        element.removeClass(variantsFrom[i][key]);
                                    }
                                }
                            }
                            if (value != '') {
                                classes = value.split(' ');
                                for (i = 0; i < classes.length; i++) {
                                    element.addClass(classes[i]);
                                }
                            }
                            //element.addClass(value);
                            break;
                        case 'style' :
                        //break;
                        default :
                            if (attrs.$normalize(key).toLowerCase().indexOf('vm.') > -1) {
                                setToModelObj(scope, attrs.$normalize(key), value);
                                $timeout(function () {
                                    scope.$apply();
                                }, 400);
                            } else {
                                attrs.$set(attrs.$normalize(key), value);//    attrs[attrs.$normalize(key)] = value;
                                $timeout(function () {
                                    scope.$apply();
                                    if (attrs.hasOwnProperty('istevenMultiSelect') && scope.$$childHead && typeof(scope.$$childHead.refreshButton) == 'function') {
                                        scope.$broadcast('refreshButton', value);
                                    }
                                }, 400);
                            }
                    }
                }
            });
        }

        function setToModelObj(obj, str, val) {
            str = str.split('.');
            while (str.length > 1) {
                obj = obj[str.shift()];
            }
            return obj[str.shift()] = val;
        }

        function refToModelObj(obj, str) {
            str = str.split('.');
            for (var i = 0; i < str.length; i++) {
                obj = obj[str[i]];
            }
            return obj;
        }

    }
})();
